export function toBrDate(time, options = { month: 'long', day: 'numeric', year: 'numeric' }) {
  const date = new Date(time);
  return date.toLocaleString('pt-br', options);
}
